import React, {useEffect, useRef} from 'react';
import { ArrowUpRight } from 'react-feather';
import {Link} from 'react-router-dom';
import emailjs from "@emailjs/browser";
import toast from 'react-simple-toasts';
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";



const Contact = (props) => {

  // Adding custom class to body 
  useEffect(() =>{
    props.location.pathname === '/' ? document.body.classList.add("home-class") : document.body.classList.add("custom-class");
    
    // Clear hamburger menu
    document.body.classList.remove("menu-closed");
    document.body.classList.remove("menu-opened");
   })

  //  Get Offerings Parameters
  const search = useLocation().search;
  const offering = new URLSearchParams(search).get("offering");
  const cta = new URLSearchParams(search).get("cta");

  // Contact Form
  const form = useRef();
  const { register, handleSubmit, resetField, formState: { errors } } = useForm();

  const onSubmit = (data) => {
    toast('Please wait, while we process your details.', { position: 'top-center', render: message => <div style={{ color: '#000', backgroundColor: '#20E1D7', padding: '4px 20px', borderRadius: '20px', border:'1px solid #fff'}}>{message}</div> })
    emailjs.sendForm(
      'service_pnxxl7m', 
      'template_m6uuasx', 
      form.current, 'RBYZowgQZ-ECERTCe')
    .then((result) => {
      setTimeout(()=>{
        toast('Congratulations! Your details has been submitted successfully!', { position: 'top-center', render: message => <div style={{ color: '#000', backgroundColor: '#20E1D7', padding: '4px 20px', borderRadius: '20px', border:'1px solid #fff'}}>{message}</div> })
      }, 3000);
        setTimeout(()=>{
          resetField('user_name');
          resetField('user_email');
          resetField('user_number');
          resetField('user_company');
          resetField('user_message');
        }, 3000)
    }, (error) => {
      toast('Something went wrong, please try again later.', { position: 'top-center', render: message => <div style={{ color: '#000', backgroundColor: '#20E1D7', padding: '4px 20px', borderRadius: '20px', border:'1px solid #fff'}}>{message}</div> })
    });
  }


   

  return (
    <React.Fragment>
      <div id="contact-page">
        <div className="contact-page pt-24">
          <div className='breadcrumbs'>
            <li><Link to='/'>Home</Link> <span>{'>'}</span> <Link to='/contact-us' className='current'>Contact Us</Link></li>
          </div>
          <h1 className="heading3">Let's Chat!</h1>
          <p>Our doors are always open for a cup of coffee and impactful discussions</p>

          <div className="form-wrapper pb-24">
              <form ref={form} onSubmit={handleSubmit(onSubmit)}>
              <div>
                <div className="input-box">
                  <label>Name</label>
                  <input
                    type='text'
                    name="user_name"
                    {...register("user_name", { required: true, minLength: 3 })}
                    placeholder='Please enter your name'/>
                    {errors.user_name ? <span className='form-errors'>Please enter a valid name.</span> : <span className="form-errors-empty"></span>}
                </div>
                <div className="input-box">
                  <label>Email</label>
                  <input
                    type='email'
                    name='user_email'
                    {...register("user_email",
                            {
                                required: true,
                                pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                            })}
                    placeholder='Please enter your email'/>
                    {errors.user_email ? <span className='form-errors'>Please enter a valid email.</span> : <span className="form-errors-empty"></span>}
                </div>
              </div>
              <div>
                <div className="input-box">
                  <label>Contact Number</label>
                  <input
                    type='number'
                    name='user_number'
                    {...register("user_number", { required: true, minLength: 10, maxLength:10})}
                    placeholder='Please enter your number'/>
                    {errors.user_number ? <span className='form-errors'>Please enter a valid 10 digit number.</span> : <span className="form-errors-empty"></span>}
                </div>
                <div className="input-box">
                  <label>Company</label>
                  <input
                    type='text'
                    name='user_company'
                    {...register("user_company", { required: true, minLength: 3})}
                    placeholder='Please enter your company name'/>
                    {errors.user_company ? <span className='form-errors'>Please enter a valid company name.</span> : <span className="form-errors-empty"></span>}
                </div>
              </div>
              <div>
                <div className="input-box">
                  <label>Message</label>
                  <textarea
                    rows='5'
                    type='text'
                    name='user_message'
                    {...register("user_message", { required: true})}
                    placeholder='Please enter your message'/>
                    {errors.user_message ? <span className='form-errors'>Please enter a valid query.</span> : <span className="form-errors-empty"></span>}
                  </div>
              </div>
              <input type="hidden" name="offering" value={offering}></input>
              <input type="hidden" name="cta" value={cta}></input>
              <button type='submit' value='send'>Submit <ArrowUpRight/></button>
            </form>
          </div>
        </div>

        <div className="footer-ribbon">
          <div className="footer-ribbon-wrapper py-16">
            <div className="footer-ribbon-wrapper-1">
              <h2>Address</h2>
              <p><a href='https://goo.gl/maps/5PB1mQWxv2VS3xU27' target={'_blank'} rel="noopener noreferrer">211, Okhla Phase III, Okhla Industrial Estate, New Delhi, Delhi 110020</a></p>
            </div>
            {/* <div className="footer-ribbon-wrapper-2">
              <h2>Phone</h2>
              <p>011 3076 3700</p>
            </div> */}
            <div className="footer-ribbon-wrapper-3">
              <h2>Email</h2>
              <p><a href="mailto:business@mslgroup.com">business@mslgroup.com</a></p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Contact;
